import { fragments } from '@/gql'
import gql from 'graphql-tag'
const q = gql`
    query WhoAmI {
      WhoAmI {
        ...whoAmI
      }
    }
    ${fragments.whoAmI}
    ${fragments.userDetails}
  `
export default q
